import {
    ApprovalCondition,
    ApprovalConditionName,
    ApprovalConditionsStatus,
    NewLoanApprovalConditionModel
} from '../models/application/application-details-loan-condition.model';

// The condition's own status, or its parent requirement's when that is further along.
export function coalesceApprovalConditionStatus(condition: ApprovalCondition): ApprovalConditionsStatus | undefined {
    const requestStatus = ApprovalConditionsStatus[condition?.RequestStatus as keyof typeof ApprovalConditionsStatus];
    const parentRequirementRequestStatus =
        ApprovalConditionsStatus[condition?.ParentRequirementRequestStatus as keyof typeof ApprovalConditionsStatus];
    return parentRequirementRequestStatus && parentRequirementRequestStatus > requestStatus
        ? parentRequirementRequestStatus
        : requestStatus;
}

// Verified is the status the portal labels "Accepted"; the Accepted enum value is labelled "Awaiting review".
export function isApprovalConditionVerified(condition: ApprovalCondition): boolean {
    return coalesceApprovalConditionStatus(condition) === ApprovalConditionsStatus.Verified;
}

const isUpdateToQuoteCondition = (condition: ApprovalCondition): boolean =>
    condition.Name === ApprovalConditionName.UpdateToQuote ||
    condition.RequirementName === ApprovalConditionName.UpdateToQuote;

export function isUpdateToQuoteAccepted(approvalConditions: NewLoanApprovalConditionModel): boolean {
    return [
        ...(approvalConditions?.DefaultApprovalConditions || []),
        ...(approvalConditions?.CustomApprovalConditions || [])
    ].some(condition => isUpdateToQuoteCondition(condition) && isApprovalConditionVerified(condition));
}
